import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-about-fs-teams',
    templateUrl: './about-fs-teams.component.html',
    styleUrl: './about.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AboutFsTeamsComponent {
  @Input() showTiles = true;
}
